import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { testimonials } from '../../mock';

const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = testimonials[i];

  return (
    <section className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">Long-Term Results</div>
          <h2 className="font-serif text-4xl lg:text-6xl text-green tracking-tight leading-[1.04]">
            Hundreds of lives <em className="italic">transformed.</em>
          </h2>
        </div>

        <div className="mt-12 reveal">
          <div className="rounded-[28px] p-8 lg:p-16 bg-[var(--brand-cream-2)] border border-[rgba(31,58,46,0.08)] max-w-4xl mx-auto text-center">
            <Quote size={36} className="text-[var(--brand-gold)] mx-auto" />
            <p className="font-serif text-2xl lg:text-4xl text-green mt-6 leading-[1.25] min-h-[3.5em]">
              “{t.quote}”
            </p>

            <div className="mt-8 flex items-center justify-center gap-1">
              {[...Array(5)].map((_, k) => (
                <Star key={k} size={16} className="fill-[var(--brand-gold)] stroke-[var(--brand-gold)]" />
              ))}
            </div>

            <div className="mt-4">
              <div className="font-serif text-xl text-green">{t.name}</div>
              <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-mute)] mt-1">Verified patient</div>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-center gap-3">
            <button
              onClick={() => setI((i - 1 + testimonials.length) % testimonials.length)}
              className="h-11 w-11 rounded-full grid place-items-center border border-[rgba(31,58,46,0.15)] hover:bg-[var(--brand-green)] hover:text-[var(--brand-cream)] transition-colors"
              aria-label="Previous"
            >
              <ChevronLeft size={18} />
            </button>
            <div className="flex items-center gap-2">
              {testimonials.map((tm, k) => (
                <button
                  key={tm.id}
                  onClick={() => setI(k)}
                  aria-label={`Go to testimonial ${k + 1}`}
                  className={`h-2 rounded-full transition-all ${
                    k === i ? 'w-8 bg-[var(--brand-green)]' : 'w-2 bg-[rgba(31,58,46,0.25)] hover:bg-[rgba(31,58,46,0.4)]'
                  }`}
                />
              ))}
            </div>
            <button
              onClick={() => setI((i + 1) % testimonials.length)}
              className="h-11 w-11 rounded-full grid place-items-center border border-[rgba(31,58,46,0.15)] hover:bg-[var(--brand-green)] hover:text-[var(--brand-cream)] transition-colors"
              aria-label="Next"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
